import React from 'react';

const Button = ({ 
  children, 
  variant = null, // Changed: default to null instead of 'primary'
  size = 'md', 
  className = '', 
  onClick,
  type = 'button',
  disabled = false,
  ...props 
}) => {
  const baseStyles = 'flex items-center justify-center overflow-hidden font-bold transition-all duration-200 cursor-pointer disabled:cursor-not-allowed';
  
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary/90 shadow-lg shadow-primary/20 rounded-lg',
    secondary: 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg',
    outline: 'bg-primary/10 text-primary dark:bg-primary/20 hover:bg-primary/20 dark:hover:bg-primary/30 border border-primary/50 rounded-lg',
    ghost: 'bg-transparent text-gray-800 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg',
  };
  
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-10 px-4 text-sm',
    lg: 'h-12 px-6 text-base',
    xl: 'h-14 px-6 text-base',
  };
  
  // Fixed: Only apply variant styles if variant is specified AND className doesn't contain background/gradient classes
  const hasCustomBackground = className.includes('bg-') || className.includes('from-') || className.includes('to-');
  const variantStyles = variant && !hasCustomBackground ? variants[variant] : '';
  
  // Fixed: Put className LAST so it always takes priority
  const classes = `${baseStyles} ${variantStyles} ${sizes[size]} ${className}`.trim();
  
  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      <span className="truncate">{children}</span>
    </button>
  );
};

export default Button;

